import { FormLabel, Grid, MenuItem, Select } from "@mui/material"
import { StringNumber } from "../../types";
import { useState } from "react";

export const SelectFrequencia = ({
  valor: _val,
  action,
  valAsNumber
}: {
  valor: StringNumber | null,
  action: any,
  valAsNumber?: boolean
}) => {



  return (
    <>
      <Grid item display={'grid'}>
        <FormLabel>Frequência</FormLabel>
        <Select
          value={_val || 'N/A'}
          onChange={action}
        >
          <MenuItem value={'N/A'}>N/A</MenuItem>
          {
            [
              {description: 'Segunda', id: 2},
              {description: 'Terça', id: 3},
              {description: 'Quarta', id: 4},
              {description: 'Quinta', id: 5},
              {description: 'Sexta', id: 6},
              {description: 'Sábado', id: 7},
              {description: 'Domingo', id: 1}
            ]
              .map(
                el => <MenuItem value={
                  valAsNumber ? el?.id : el?.description
                }>{el?.description}</MenuItem>
              )
          }
        </Select>
      </Grid>
    </>
  )
}
